import { type BranchOption, type ResolvedBranchNode } from '@/lib/branchTypes'

type DefaultPrimaryArgs = {
  nodeId: string
  options: BranchOption[]
  nextNodeId: string | null
  selectedPath: string[]
  nodes: Record<string, ResolvedBranchNode>
}

// If the user landed on a follow-up branchpoint without picking, auto-suggest the recommended plan.
export const getDefaultPrimaryTargetId = ({
  nodeId,
  options,
  nextNodeId,
  selectedPath,
  nodes,
}: DefaultPrimaryArgs): string | null => {
  const isFirstBranchPoint = nodeId === selectedPath[0]
  if (isFirstBranchPoint || nextNodeId) return null
  const primaryOption = options.find(
    o => o.targetId && (o.primary || nodes[o.targetId]?.primary)
  )
  if (!primaryOption?.targetId) return null
  if (selectedPath.includes(primaryOption.targetId)) return null
  return primaryOption.targetId
}
